import { render } from "./SlideFadeTransition.vue?vue&type=template&id=784d6b82&scoped=true"
const script = {}

import "./SlideFadeTransition.vue?vue&type=style&index=0&id=784d6b82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784d6b82"]])

export default __exports__